import config from "config/config.jsx";
const baseUrl = config.API_BASE_URL;

export const URL = {

      USER_LOGIN: `${baseUrl}/login/loginUser`,
      FORGETPASSWORDOTP: `${baseUrl}/login/forgotPasswordSendOtp`,
      RESTARTPASSWORD: `${baseUrl}/login/forgotPasswordReset`,
      GET_ALL: `${baseUrl}/customer/get_by_customerId`,
      COLLECTION_LIST : `${baseUrl}/payment/collectionList`,
      OVERDUE_LIST : `${baseUrl}/emi/scheduleList`,
      FULL_DETAILS: `${baseUrl}/customer/full_details`,
      UPDATE_CUSTOMER_DETAILS: `${baseUrl}/customer/customer_update`,
      UPDATE_EMPLOYMENT_DETAILS: `${baseUrl}/employment/update`,
      UPDATE_REFERENCE_DETAILS: `${baseUrl}/reference/update`,
      UPDATE_ADDRESS_DETAILS: `${baseUrl}/address/update_by_customer`,
      LOAN_LIST: `${baseUrl}/loans/details`,
      GET_ALL_EMI: `${baseUrl}/payment/emi_schedule`,
      EMPLOYEE_LIST: `${baseUrl}/login/employees`,
      EDIT_EMPLOYEE: `${baseUrl}/login/updateUserFields`,
      CREATE_EMPLOYEE: `${baseUrl}/login/create`,
      DOCUMENT_GET_ALL: `${baseUrl}/documents/get_all`,
      DISBURSAL_LIST: `${baseUrl}/disbursal/list`,
      DISBURSAL_VIEW: `${baseUrl}/disbursal/disbursal_view`,
      COUNTS: `${baseUrl}/customer/status_counts`,
      LOAN_REJECT: `${baseUrl}/loans/rejected`,


     UPDATE_BANK_DETAILS: `${baseUrl}/bank/update`,
     PRODUCT_LIST: `${baseUrl}/products/details`,
     PRODUCT_CREATE: `${baseUrl}/products/create`,
     PRODUCT_CREATE: `${baseUrl}/products/create`,

     ALL_STATUS_CHANGE: `${baseUrl}/status/update`,
     LOGIN_FEE: `${baseUrl}/api/login-fee/all`,
     LOGIN_FEE_MASTER: `${baseUrl}/api/login-fee/master`,
     LOGIN_FEE_STATUS: `${baseUrl}/api/login-fee/master/status`,

     REJECT_ON_APP: `${baseUrl}/step-status/reject`,
     RJECT_BY_LOAN: `${baseUrl}/step-status/update-all`,

      GET_USER_LIST: `${baseUrl}/login/users`,
      GET_PRIVILEGE_LIST: `${baseUrl}/privilege/get_all`,
      USER_PRIVILEGE:`${baseUrl}/privilege/get_user_privilege`,
      SET_TITLE: `${baseUrl}/privilege/add_title`,
      SET_SUBTITLE: `${baseUrl}/privilege/add_subtitle`,
      UPDATE_USER_PRIVILEGE: `${baseUrl}/privilege/update_privilege`,
      ASSIGN_BULK_PRIVILEGE: `${baseUrl}/login/assign_bulk_privilege`,
      GET_TODAY_EMI: `${baseUrl}/emi/emiYesterday`,
      CIBIL_VIEW: `${baseUrl}/jsonReport/generate-cibil-pdf`,

      DIGILOCKER_VIEW: `${baseUrl}/jsonReport/digilockerView`,
      ONEMONEY_VIEW: `${baseUrl}/jsonReport/oneMoneySalaryView`,
      DISBURSAL_STATUS: `${baseUrl}/disbursal/Status`,


      REJECT_COMMNET:`${baseUrl}/comment/export/type-1/csv`,

      JUSAPY_MANDATE_REGISTRATION: `${baseUrl}/web/mandates`,
      MANDATE_REGISTRATION_LIST: `${baseUrl}/juspayMandates/registered`,
      RECURRING_PAYMENTS: `${baseUrl}/juspayMandates/execution`,

      PAYMENT_LINK: `${baseUrl}/payin/create-link`,
      PAYMENTS: `${baseUrl}/payments/adjust`,
      COMMENT_ADD: `${baseUrl}/comment/add`,
      DOCUMENT_UPLOAD: `${baseUrl}/documents/upload`,
      UPDATE_DOCUMENT: `${baseUrl}/documents/update`,
      Comment_GET: `${baseUrl}/comment/get`,
      LOAN_AGREEMENT: `${baseUrl}/agreement/generate`,
      KFS_AGREEMENT: `${baseUrl}/kfs-agreement/generate`,

      DISBURSAL_REPORTING: `${baseUrl}/reporting/disbursement_summary`,

      SUCCESS_FUND: `${baseUrl}/disbursal/completed`,
      APPROVE_REQUEST_PAYOUT: `${baseUrl}/disbursal/approve`,

      RULE_ENGINE: `${baseUrl}/rule/engine`,
      RERUN_RULE_ENGINE: `${baseUrl}/rule/engine`,
      BRE_ACTION_UPDATE: `${baseUrl}/bre_action/update_status`,
      BRE_RULES: `${baseUrl}/bre/getAll`,
      UPDATE_POLICY: `${baseUrl}/bre/update`,
      REJECT_SUMMERY: `${baseUrl}/bre_action/list_bre_action`,



SEND_NOC:`${baseUrl}/agreements/send-noc`,
LOAN_OUTSTANDING: `${baseUrl}/emi/loan-outstanding`,
      E_SIGN:`${baseUrl}/esign/details`,
      LAT_AND_LONG:`${baseUrl}/api/permission/get`,
      EDIT_SOFT_APPROVAL: `${baseUrl}/soft-approval/edit`,
      UPDATE_STEP_STATUS:`${baseUrl}/soft-approval/update-step-status`,
      REPORTING_PAYMENT_SUMMARY: `${baseUrl}/reporting/payment-summary`,
      DIGILOCKER_ADDRESS: `${baseUrl}/jsonReport/getDigilockerAddress`,
      CUSTOMER_EYE_VIEW: `${baseUrl}/jsonReport/aadhaar_from_digilocker`,
      SoftApprovalList: `${baseUrl}/soft-approval`,

     STATUS_BRE_BUTTON: `${baseUrl}/rule/status`,
     TOGGLE_BRE_BUTTON: `${baseUrl}/rule/toggle`,
     STATUS_BRE_FINANCE: `${baseUrl}/rule/status-finance`,
     TOGGLE_BRE_FINANCE: `${baseUrl}/rule/toggle-finance`,
     RUN_NOW_BRE_ALL: `${baseUrl}/rule/run-now`,
     BLOCKED_AREA: `${baseUrl}/blocked`,
     RULE_AGENT: `${baseUrl}/policies`,
     RULE_FINANCE: `${baseUrl}/finance-policies`,
    OVERDUE_REPORTING: `${baseUrl}/reporting/overdueReporting`,
    BUREAU_REPORTING: `${baseUrl}/reporting/bureauReporting`,
    NOC_GENERATE: `${baseUrl}/noc/generate`,
   SAVE_ONEMONEY: `${baseUrl}/jsonReport/saveOneMoney`,
   EMI_CALCULATE: `${baseUrl}/emi/calculate`,
   CURRENT_LOCATION: `${baseUrl}/location/current`,
   GENERATE_QR: `${baseUrl}/qr/create`,
   GET_QR_CODE: `${baseUrl}/qr/download`,
   DISBURSAL_OUTSTANDING_REPORTING: `${baseUrl}/reporting/disbursal-with-outstanding`,
   FEES_WAVE_OFF: `${baseUrl}/fees/wave-off/loan`,
  RECURRING_EXCEL: `${baseUrl}/recurring/export-excel`,


MANDATE_UPDATE_REVOKE: `${baseUrl}/web/mandates/update-revoke`,
GET_QR_DETAILS: `${baseUrl}/qr/details`,
REGISTRATION_EXCEL: `${baseUrl}/recurring/RegistrationExcel`,
MANDATE_NOTIFICATION: `${baseUrl}/mandates/notify`,


// Calller REmarks Apis

CALL_COUNT: `${baseUrl}/call-remarks/today`,
CALL_REMARKS_LIST: `${baseUrl}/call-remarks/list`,
ADD_REMARKS:`${baseUrl}/call-remarks/add`,
CALLER_CALL_COUNT: `${baseUrl}/call-remarks/count`,
GET_CODES_DISPOSITION:`${baseUrl}/call-disposition/all`,
CASES_ASSIGNED: `${baseUrl}/assignment/my-cases`,
CASE_MARK_SUCCESS: `${baseUrl}/assignment/mark-success`,
CALLER_LIST:  `${baseUrl}/login/users`,
GENERATE_PTP: `${baseUrl}/promise_to_pay/add`,
GET_PROMISE_TO_PAY: `${baseUrl}/promise_to_pay/get_promise`,
STATUS_UPDATE_OF_PROMISE: `${baseUrl}/promise_to_pay/update_status`,
RAZORPAY_REFUND: `${baseUrl}/api/razorpay/refund`,
CHAT_BOAT: `${baseUrl}/chat/ask`,
MANUAL_ASSIGN: `${baseUrl}/assignment/manual-assign`,
BULK_ASSIGN_EXCEL: `${baseUrl}/assignment/manual-assign-excel`,
CALLER_SUMMARY: `${baseUrl}/call-remarks/caller-summary`,

// Other LSP Cases
OTHER_LSP_UPLOAD: `${baseUrl}/other-lsp-cases/upload-excel`,
OTHER_LSP_MY_CASES: `${baseUrl}/other-lsp-cases/my-cases`,
OTHER_LSP_CREATE_LINK: `${baseUrl}/other-lsp-cases/payment-link/create`,
OTHER_LSP_FETCH_LINK: `${baseUrl}/other-lsp-cases/payment-link/fetch`,
OTHER_LSP_FETCH_ALL_LINKS: `${baseUrl}/other-lsp-cases/payment-link/fetch-all`,



// Finance 

GET_ALL_COMPANY:`${baseUrl}/api/company/list`,
UPDATE_COMPANY:`${baseUrl}/api/company/update`,
ADD_COMPANY:`${baseUrl}/api/company/create`,
ADD_COMPANY_DOCUMENTS:`${baseUrl}/api/company/upload-documents`,
COMPANY_LIST_BY_CODE:`${baseUrl}/api/company/company/dropdown`,

GET_ALL_BEANCHES:`${baseUrl}/api/branch/list`,
COMPANY_BRANCH:`${baseUrl}/api/branch/branch/all`,
BRANCH_ADD:`${baseUrl}/api/branch/create`,
BRANCH_EDIT:`${baseUrl}/api/branch/update`,

GET_ALL_AGENT:`${baseUrl}/api/agent/search`,
EDIT_AGENT: `${baseUrl}/api/agent/update`,
ADD_AGENT:`${baseUrl}/api/agent/create`,
ADD_DOCUMENTS_AGENT:`${baseUrl}/api/agent/upload-documents`,

GET_WALLET:`${baseUrl}/api/wallet/balance`,
URL_RAISE_REQUEST:`${baseUrl}/api/wallet/request`,
GET_REQUESTS:`${baseUrl}/api/wallet/requests`,
APPROVE_REQUEST:`${baseUrl}/api/wallet/approve`,
REJECT_REQUEST: `${baseUrl}/api/wallet/reject`,
WITHDRAW_REQUEST:`${baseUrl}/api/wallet/withdraw/request`,
WITHDRAW_APPROVE:`${baseUrl}/api/wallet/withdraw/approve`,
WITHDRAW_REJECT:`${baseUrl}/api/wallet/withdraw/reject`,
WALLET_TRANSACTIONS:`${baseUrl}/api/wallet/transactions`,
WALLET_TRANSACTIONS_EXPORT:`${baseUrl}/api/wallet/transactions/export`,
EMI_CLUCULATOR_FOR_FINANCE:`${baseUrl}/loans/preview-reducing`,
OVERALL_COLECTION_REPORT:`${baseUrl}/reporting/loan-collection-overview`,
CUSTOMER_LOAN_JOURNEY:`${baseUrl}/customer-loan-journey`,
PENDING_APPROVAL_EXPORT:`${baseUrl}/customer-loan-journey/export-pending-approval`,
MARK_REJECTED_BY_STATUS:`${baseUrl}/step-status/mark-rejected-by-customer-status`,
MANDATE_NOTIFICATIONS:`${baseUrl}/mandates/notifications`,
MANDATE_EXECUTE:`${baseUrl}/mandates/execute`,
ACCOUNT_STATEMENT_PDF:`${baseUrl}/statement/account/pdf`,

// Lender
ADD_LENDER: `${baseUrl}/lender/create`,
GET_ALL_LENDER: `${baseUrl}/lender/all`,
ASSIGN_LENDER: `${baseUrl}/lender/assign`,

};
